import React, { type JSX } from 'react';
import Grid from '@mui/material/Grid';
import { holeGeschaedigten } from '../../shared/frontend/holeGeschaedigten';
import { Vorgang } from '../../types';

type Props = {
  readonly vorgang: Vorgang;
};

export default function VorgangInfoBar({ vorgang }: Props): JSX.Element {
  const auftraggeber = holeGeschaedigten(vorgang);

  let auftraggeberName = '-';
  if (auftraggeber) {
    if (auftraggeber.firmenname) {
      auftraggeberName = auftraggeber.firmenname;
    } else {
      auftraggeberName = `${auftraggeber.vorname ?? ''} ${auftraggeber.nachname ?? ''}`;
    }
  }

  return (
    <Grid container className="vorgang-toolbar__info">
      <Grid>{auftraggeberName}</Grid>
      <Grid>{vorgang?.fahrzeugdaten?.kennzeichen ?? '-'}</Grid>
      <Grid>{vorgang?.fahrzeugdaten?.herstellername ?? '-'}</Grid>
      <Grid>{vorgang?.fahrzeugdaten?.haupttypname ?? '-'}</Grid>
    </Grid>
  );
}
